import { render } from "./WelcomeModal.vue?vue&type=template&id=3155fa2b"
import script from "./WelcomeModal.vue?vue&type=script&lang=js"
export * from "./WelcomeModal.vue?vue&type=script&lang=js"

import "./WelcomeModal.vue?vue&type=style&index=0&id=3155fa2b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__